/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Keys_New_DescInputs */

const en_settings_keys_new_desc = /** @type {(inputs: Settings_Keys_New_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy it now. You won't see it again.`)
};

const id_settings_keys_new_desc = /** @type {(inputs: Settings_Keys_New_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salin sekarang. Tidak akan ditampilkan lagi.`)
};

/**
* | output |
* | --- |
* | "Copy it now. You won't see it again." |
*
* @param {Settings_Keys_New_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_keys_new_desc = /** @type {((inputs?: Settings_Keys_New_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Keys_New_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_keys_new_desc(inputs)
	return en_settings_keys_new_desc(inputs)
});